/**
 * Time interval utilities
 */

export function isTimeInterval(timeObj: number, interval: number): boolean {
  return (Date.now() / 1000 - timeObj) < interval - 1;
}

export function getCurrentTime(): number {
  return Date.now() / 1000;
}
